<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="o-form -two-columns">
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <form
                v-else
                @submit.prevent="saveItem(form)"
                autocomplete="off"
            >
                <div class="o-row -gutter-xs">
                    <div class="o-col w-1/3">
                        <div class="o-col__inner -sticky">
                            <h1 class="o-form__title">Champs</h1>
                            <Listbox
                                v-bind:listbox="listbox"
                            />
                        </div>
                    </div>

                    <div class="o-col w-2/3">
                        <fieldset class="o-form__inner">
                            <h1 class="o-form__title">Formulaire projet</h1>
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            >
                            <input
                                type="hidden"
                                name="customtag_label_id"
                                v-model="form.customtag_label_id"
                            >
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Nom"
                                    v-model="form.name"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="shortname"
                                    placeholder="Shortname"
                                    v-model="form.shortname"
                                />
                            </div>
                            <div class="o-form__item">
                                <button class="o-button" :loading="$apollo.loading" color="primary">Sauvegarder</button>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { CUSTOMTAGLABELS } from '@/graphql/tag/queries'
    import { PROJECTFORMTEMPLATE } from '@/graphql/project/queries'
    // import { UPSERTCUSTOMTAG, DELETETAG } from '@/graphql/tag/mutations'
    // import { removeNULL } from '@/js/utilities'

    export default {
        name: 'ProjectTemplate',
        props: {
        },
        apollo: {
            customTags: {
                query: CUSTOMTAGLABELS,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(customTagLabels) {
                    this.listbox.listItems=Object.assign([], this.fields);
                    customTagLabels.customTagLabels.forEach(function(item){
                        this.listbox.listItems.push({
                            name: item.name,
                            value: 'custom_tag_'+item.id,
                            customTagLabelID: item.id
                        })
                    }.bind(this))
                    return customTagLabels;
                },
                variables() {
                }
            },
            projectFormTemplate: {
                query: PROJECTFORMTEMPLATE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                // update(data) {
                //     return data;
                // },
                variables() {
                }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: [],
                    addButton: false,
                    deleteButton: false,
                    copyButton: false,
                    actionButton: "Ajouter",
                },
                form: {},
                newItem: {
                    id: 0,
                    name: null,
                },
                fields: [
                    {
                        name: 'No de contrat',
                        value: 'contract_number',
                    },
                    {
                        name: 'Nom du projet',
                        value: 'name'
                    },
                    {
                        name: 'Description',
                        value: 'description'
                    },
                    {
                        name: 'Date de début',
                        value: 'start_date'
                    },
                    {
                        name: 'Date de fin',
                        value: 'end_date'
                    },
                    {
                        name: 'Chargé de projet',
                        value: 'project_manager'
                    },
                    {
                        name: 'Clients',
                        value: 'customers'
                    },
                    {
                        name: 'Contacts client',
                        value: 'customer_contacts'
                    },
                    {
                        name: 'Lieux de rassemblement',
                        value: 'customer_locations'
                    },
                    {
                        name: 'Superviseur des travaux',
                        value: 'name'
                    },
                ]               
            }
        },
        computed: {
        },
        mounted: async function(){
            // this.listbox.listItems=Object.assign([], this.fields);
            // this.form=Object.assign({}, this.newItem);
        },
        methods: {
            // setSelected(item){
            // },
            // setNewItem(){
            // },
            // deleteItem(form){
            // },
            // saveItem(form) {
                // form=removeNULL(form);
                // this.$apollo.mutate({
                //     mutation: UPSERTCUSTOMTAG,
                //     variables: { ...form },
                //     update: (store, { data: { upsertCustomTag } }) => {
                //         if(!form.id){
                //             let myVariables={}
                //             if(this.selectedParent_id) myVariables.customtag_label_id = this.selectedParent_id
                //             const data = store.readQuery({
                //                 query: CUSTOMTAGS,
                //                 variables: myVariables
                //             })
                //             data.customTags.push(upsertCustomTag);
                //             store.writeQuery({
                //                 query: CUSTOMTAGS,
                //                 data,
                //                 variables: myVariables
                //             })
                //         }
                //         this.setSelected(upsertCustomTag)
                //     }
                // }).then(() => {
                //     this.$q.notify({type: 'positive', message: "CustomTag : "+form.name, caption: "Informations sauvegardées"})
                // }).catch(e => {
                //     if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                // }).finally(() => {
                // })
            // }
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
